export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9283.fa60ddf6.jpg";